export default "__VITE_ASSET__DF$gj3rZ__"